import React from "react";

function TaskTab({ data = {}, onChange }) {
  const handleInput = (e) => {
    const { name, value } = e.target;
    onChange({ ...data, [name]: value });
  };

  const formatDate = (dateStr) => {
    return dateStr ? new Date(dateStr).toISOString().slice(0, 10) : "";
  };

  return (
    <div className="bg-white p-3 rounded-md shadow-md border">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">
        
        {/* Task Name */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Task Name</label>
          <input
            name="task_name"
            value={data.task_name || ""}
            onChange={handleInput}
            className="border rounded px-2 py-1 focus:ring-2 focus:ring-blue-400"
            placeholder="Enter task name"
          />
        </div>

        {/* Phase */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Phase</label>
          <input
            name="phase"
            value={data.phase || ""}
            onChange={handleInput}
            className="border rounded px-2 py-1"
            placeholder="e.g. Planning"
          />
        </div>

        {/* Start Date */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Start Date</label>
          <input
            type="date"
            name="start_date"
            value={formatDate(data.start_date)}
            onChange={handleInput}
            className="border rounded px-2 py-1"
          />
        </div>

        {/* End Date */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">End Date</label>
          <input
            type="date"
            name="end_date"
            value={formatDate(data.end_date)}
            onChange={handleInput}
            className="border rounded px-2 py-1"
          />
        </div>

        {/* Status */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Status</label>
          <input
            name="status"
            value={data.status || ""}
            onChange={handleInput}
            className="border rounded px-2 py-1"
            placeholder="e.g. Not Started"
          />
        </div>
      </div>
    </div>
  );
}

export default TaskTab;
